import React from 'react';
import Text, { Inline } from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import {
  InfoInstructionsBox,
  StyledDash,
  StyledInstructionsBox,
  StyledDot
} from './components';

const GitHubExplanation = () => (
  <Flex position='relative' direction='column' ml='3rem'>
    <StyledInstructionsBox mt='23.1rem' mb='0.7rem'>
      <Text size='normal' lineHeight='1.45rem'>
        Organizations that have a green check mark are already connected to
        LinearB.
      </Text>
      <StyledDash width='9rem' height='9.85rem' left='-9rem' top='50%'>
        <StyledDot right='-0.1rem' top='-0.35rem' />
        <StyledDash width='18.1rem' right='100%' top='100%'>
          <StyledDot left='-0.3rem' top='-0.3rem' />
        </StyledDash>
      </StyledDash>
    </StyledInstructionsBox>
    <StyledInstructionsBox gap='1rem' direction='column' mb='1.8rem'>
      <Text size='normal' lineHeight='1.45rem'>
        You have two options to add a new organization to LinearB:
      </Text>
      <Text size='normal' lineHeight='1.45rem'>
        <Inline size='normal' lineHeight='1.45rem' weight='700'>
          Grant:
        </Inline>{' '}
        You have permission to install GitHub Apps to the organization.
      </Text>
      <Text size='normal' lineHeight='1.45rem'>
        <Inline size='normal' lineHeight='1.45rem' weight='700'>
          Request:
        </Inline>{' '}
        You need to seek approval from your org admin. Clicking Request notifies
        your admin via email.
      </Text>
      <StyledDash width='6.5rem' left='-6.5rem' bottom='3.9rem'>
        <StyledDot right='-0.1rem' top='-0.35rem' />
        <StyledDot left='-0.3rem' top='-0.3rem' />
      </StyledDash>
    </StyledInstructionsBox>
    <InfoInstructionsBox>
      <Text size='normal' lineHeight='1.45rem' weight='700' mt='0.2rem'>
        Click the green authorize button after granting or requesting permission
        for all applicable organizations.
      </Text>
      <StyledDash
        bottomDash
        width='1.8rem'
        height='3.8rem'
        left='-2rem'
        bottom='50%'
      >
        <StyledDot right='-0.3rem' bottom='-0.3rem' />
        <StyledDash width='4.7rem' right='100%'>
          <StyledDot left='-0.3rem' top='-0.3rem' />
        </StyledDash>
      </StyledDash>
    </InfoInstructionsBox>
  </Flex>
);

export default GitHubExplanation;
